import React, { useEffect, useState } from "react";
import { useLocation, Link } from 'react-router-dom'
import "./navbar.css";
import { Button, NormalButton } from "../../utils/button";
import content from "../../content.json";

const SCROLL_THRESHOLD = 40; // px

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > SCROLL_THRESHOLD);
    };

    // run once to set initial state
    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);



  const location = useLocation()

  // navigate to a section on the home page. If already on home, smooth-scroll.
  const goToSection = (id) => {
    setIsOpen(false);

    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      localStorage.setItem("scrollToSection", id);
      window.location.href = "/";
    }
  };


  return (
    <nav
      className={`navbar ${isScrolled ? "scrolled" : ""}`}
    >
      <div className="logo">
        <a href="#home" onClick={(e) => { e.preventDefault(); goToSection('home') }} className="logo-link">
          <img src="/logo.png" alt="BluSuite" className="nav-logo" />
        </a>
      </div>

      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
      </div>

      <div className={`spacer ${isOpen ? "active" : ""}`}>
        <div className="nav-item-dropdown services-dropdown">
          <a href="#services" onClick={(e) => { e.preventDefault(); goToSection('services') }}>
            <NormalButton text="Services" />
          </a>
          <div className="dropdown-menu">
            {Object.entries(content.service_cards).map(([key, service]) => (
              <Link to={`/services/${key}`} key={key} className="dropdown-item" onClick={() => setIsOpen(false)}>
                {service.title}
              </Link>
            ))}
          </div>
        </div>
        <a href="#blogs" onClick={(e) => { e.preventDefault(); goToSection('blogs') }}>
          <NormalButton text="Blogs" />
        </a>
        <a href="#about" onClick={(e) => { e.preventDefault(); goToSection('about') }}>
          <NormalButton text="About" />
        </a>
        <a href="#contact" onClick={(e) => { e.preventDefault(); goToSection('contact') }}>
          <Button text="Contact" />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;